/* Vue 3D : boutons d'angle. Un clic oriente la caméra et coupe la rotation automatique. */
(function () {
  function brancher(zone) {
    Array.prototype.forEach.call((zone || document).querySelectorAll('.ap3d'), function (section) {
      if (section.__ap3d) return;
      section.__ap3d = true;
      var viewer = section.querySelector('[data-ap3d]');
      var boutons = Array.prototype.slice.call(section.querySelectorAll('[data-orbite]'));
      if (!viewer || !boutons.length) return;

      boutons.forEach(function (b) {
        b.addEventListener('click', function () {
          viewer.removeAttribute('auto-rotate');
          viewer.setAttribute('camera-orbit', b.getAttribute('data-orbite'));
          if (typeof viewer.resetInteractionPrompt === 'function') viewer.resetInteractionPrompt();
          boutons.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
      });

      /* Dès que le client manipule la pala lui-même, plus aucun bouton n'est « actif ». */
      viewer.addEventListener('camera-change', function (e) {
        if (e.detail && e.detail.source === 'user-interaction') {
          boutons.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { brancher(); });
  else brancher();
  document.addEventListener('shopify:section:load', function (e) { brancher(e.target); });
})();
